import { Component, OnInit } from '@angular/core';
import { TestRequestService } from '../../services/test-request.service';
import { Observable } from 'rxjs/Observable';
import { TestRequest } from '../../models/TestRequest';
import { HelperService } from '../../services/helper.service';
import { Router } from '@angular/router';
import { TestAccession } from '../../models/TestAccession';

@Component({
  selector: 'app-requests-list',
  templateUrl: './requests-list.component.html',
  styleUrls: ['./requests-list.component.css']
})
export class RequestsListComponent implements OnInit {
  TestRequests: TestRequest[] = [];
  
  constructor(private testRequestService: TestRequestService,
    private helperSerivce: HelperService,
    private router: Router) {
  }

  ngOnInit() {
   
  }
  delete(testReuest) {
    console.log(testReuest);
    this.testRequestService.deleteTestRequest(testReuest.Id).subscribe(data => {
      this.TestRequests = this.helperSerivce.Without(this.TestRequests, item => { return item.Id == testReuest.Id; })
    });
  }

  onFilter(data) {
    this.loadTestRequest(data);
  }
  private loadTestRequest(searchCriteria) {
    this.testRequestService.getTestRequests(searchCriteria).subscribe(data => { this.TestRequests = data; });
  }

   viewDetails(testRequest) {
     this.router.navigate(['manage/request-details'], { queryParams: { id: testRequest.Id } });
  }
}
